import { RATING_AGE } from "@/lib/constants";
import styles from "@/styles/Video.module.scss";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AgeRestriction(_ref) {
  var watch = _ref.watch;
  var episode = watch.episode;
  var age = RATING_AGE[episode.rating];
  return /*#__PURE__*/_jsx("div", {
    className: styles.age,
    children: /*#__PURE__*/_jsxs("p", {
      className: styles.message,
      children: [age, "\u6B73\u4EE5\u4E0A\u306E\u65B9\u304C\u3054\u8996\u8074\u3044\u305F\u3060\u3051\u307E\u3059\u3002"]
    })
  });
}